// extracted by mini-css-extract-plugin
module.exports = {"campoPesquisa":"ParametrosConsulta_campoPesquisa__3OToz","botao":"ParametrosConsulta_botao__xNN1J","icone":"ParametrosConsulta_icone__2eRLX"};